//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import { queryServiceByGroup } from '@/https/user.js'
import TMenu from '@/TShareComponent/TMenu'
import TServiceList from '@/TShareComponent/TServiceList'

export default {
  components: {
    TMenu,
    TServiceList,
  },

  data () {
    return {
      serviceLoading: false,
      serviceList: [],
    }
  },

  created () {
    this.setServiceList()
  },

  methods: {
    filterHook (list) {
      return list.map((el) => {
        return {
          img: el.fwtb,
          name: el.fwmc,
          url: el.fwnr,
          ...el,
        }
      }) || []
    },

    async setServiceList () {
      this.serviceLoading = true
      const { data } = await queryServiceByGroup()
      this.serviceList = data || []
      this.serviceLoading = false
    },
  },
}
